import {isFeatureEnabled} from '@github-ui/feature-flags'

import {SegmentedControlViewSwitch} from './segmented-control'
import {TabNavViewSwitch} from './tab-nav'
import type {ViewSwitchProps} from './types'

export const ViewSwitch = (props: ViewSwitchProps) => {
  return isFeatureEnabled('markdown_experience_toolbar_redesign') ? (
    <SegmentedControlViewSwitch {...props} />
  ) : (
    <TabNavViewSwitch {...props} />
  )
}
